import React from 'react'

function Address() {
    return (
        <div>
            <section class="text-gray-600 font-roboslab">
                <div class="container px-5 py-1 mx-auto">
                    <div class="flex flex-col text-center w-full mb-12">
                        <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">COMPANY ADDRESS</h1>
                        <p class="lg:w-2/3 mx-auto leading-relaxed text-base">xxTH FLOOR, UNIT NUMBER 12xx, PLOT NO. 5x, LOxxX CITY CENTRE, BLOCK- xW, SECTOR x2, NOIDA, Gautam Buddha Nagar, Madhya Pradesh, 201301</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Address
